/**
 * Created by portiz on 8/24/2018.
 */
import LanguageManager from './language-manager';
import Settings from './settings';
import SessionManager from './session-manager';
import CurrencyManager from './currency-manager';

class ApiCalls {

    /**
     * To call to enter a new password when the user forgets his passowrd
     * @param token The token included in the email
     * @param password The password
     * @param passwordRetype The password retype
     * @returns {*}
     */
    static callPasswordResetNewPassword(token, password, passwordRetype){
        let data = {
            Token: token,
            Password: password,
            PasswordRetype: passwordRetype
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getPasswordResetNewPasswordAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }


    /**
     * To reset the password by email petition
     * @param email The user email
     * @returns {*} returns the data
     */
    static getPasswordResetPetition(email){
        let data = {
            LangCode: LanguageManager.getLanguage(),
            Email: email,
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getPasswordResetPetitionAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * To show the client their profiles activities
     */
    static getProfilesActivity(){
        let data = {
            LangCode: LanguageManager.getLanguage(),
            Token: SessionManager.getSession(),
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getProfilesActivityAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }


    /**
     * Get the report usages
     * @param userId The id of the client
     * @param dateFrom The date from
     * @param dateTo The date to
     * @returns {*}
     */
    static getReportUsage(userId, dateFrom, dateTo)
    {
        let data = {
            LangCode: LanguageManager.getLanguage(),
            Token: SessionManager.getSessionEmployee(),
            CreatedFrom: dateFrom,
            CreatedTo: dateTo,
            UserId: userId
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getReportUsageAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Return subscriptions details as the total quantity by plans, etc.
     * @param planId The id of the plan if any
     * @param dateFrom The date from
     * @param dateTo The date to
     */
    static getReportSubscription(planId, dateFrom, dateTo)
    {
        let data = {
            LangCode: LanguageManager.getLanguage(),
            Token: SessionManager.getSessionEmployee(),
            DateFrom: dateFrom,
            DateTo: dateTo,
        };
        if(planId !== null)
        {
            data.Subscription = {
                Plan : {
                    Id : planId
                }
            }
        }

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getReportSubscriptionsAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Return the roles
     * @returns {*}
     */
    static getRoles(){
        let data = {
            LangCode: LanguageManager.getLanguage(),
            Token: SessionManager.getSessionEmployee()
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getRolesReadAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Return the status accounts
     * @returns {*}
     */
    static getStatusAccount(){

        let data = {
            LangCode: LanguageManager.getLanguage(),
            Token: SessionManager.getSessionEmployee()
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getStatusAccountReadAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }


    /**
     * Validates a coupon and return the couponPlatformId
     * @param couponCode The coupon code
     * @returns {*}
     */
    static getCouponValidate(couponCode){
        let data = {
            Coupon: {
                Code: couponCode
            },
            LangCode: LanguageManager.getLanguage()
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getCouponValidateAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Coupons to return
     * @param name The name of the coupon
     * @param code The code of the coupon
     * @param available The available ones
     * @param currency The currency
     * @param platformId The platform Id
     * @param currentPage The current page of the search
     * @param limiter How many results we want.
     * @returns {*}
     */
    static getCoupons(name, code, available, currency, platformId,  currentPage, limiter)
    {
        let data = {
            LangCode: LanguageManager.getLanguage(),
            Token: SessionManager.getSessionEmployee(),
            PageFrom: currentPage,
            Limiter: limiter,
            Coupon: {
                Name: name,
                Code: code,
                Available: available,
                PlatformId: platformId,
                Currency: currency
            }
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getCouponsReadAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }


    /**
     * Creates a coupon
     * @param name The name of the coupon
     * @param code The code of the coupon
     * @param currency The currency of the coupon
     * @param percentOff The percentage off
     * @param amountOff The amount off
     * @param duration The duration
     * @param durationInMonths
     * @param maxRedemptions
     * @param reedemBy
     * @param available
     */
    static createCoupon(name, code, currency, percentOff, amountOff, duration, durationInMonths, maxRedemptions, reedemBy, available)
    {
        let data = {
            LangCode: LanguageManager.getLanguage(),
            Token: SessionManager.getSessionEmployee(),
            Coupon: {
                Name: name,
                Code: code,
                Currency: currency !== null && String(currency).trim().length !== 0 ? String(currency) : null,
                PercentOff: percentOff !== null && String(percentOff).trim().length !== 0 ? String(percentOff) : null,
                AmountOff: amountOff !== null && String(amountOff).trim().length !== 0 ? String(amountOff) : null,
                Duration: duration !== null && String(duration).trim().length !== 0 ? String(duration) : null,
                DurationInMonths: durationInMonths !== null && String(durationInMonths).trim().length !== 0 ? String(durationInMonths) : null,
                MaxRedemptions: maxRedemptions,
                RedeemBy: reedemBy,
                Available: available
            }
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getCouponCreateAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }


    /**
     * To register the user for the one page form
     * @param firstName The first name the user
     * @param lastName The last name of the user
     * @param phone The user phone
     * @param addressLine1 The address line 1
     * @param addressLine2 The address line 2
     * @param city The city
     * @param state The state of the address
     * @param stateIso The iso code of the state
     * @param country The country
     * @param zipCode The zip code
     * @param countryIso The country iso code
     * @param planId The id of the plan
     * @param stripeToken The stripe token
     * @param subscriptionQuantity The quantity of subscriptions
     * @param email The email
     * @param username The username
     * @param password The password
     * @param passwordRetype The password Retype
     * @param couponPlatformId The coupon platfrom
     * @returns {*}
     */
    static registerOnePageForm(firstName, lastName, phone, addressLine1, addressLine2, city, state, stateIso,
                               country, zipCode, countryIso, planId, stripeToken, subscriptionQuantity, email,
                               username, password, passwordRetype, couponPlatformId) {

        let subscriptionRequest = {
            LangCode: LanguageManager.getLanguage(),
            Token: SessionManager.getSessionEmployee(),
            Phone: typeof phone !== 'undefined' && phone !== null && phone.trim().length > 0 ?
                phone.trim().replace(/\D/g, "") : null,
            AddressLine1: addressLine1 !== null && String(addressLine1).trim().length !== 0 ? String(addressLine1) : null,
            AddressLine2: addressLine2 !== null && String(addressLine2).trim().length !== 0 ? String(addressLine2) : null,
            City: city !== null && String(city).trim().length !== 0 ? String(city) : null,
            State: state !== null && String(state).trim().length !== 0 ? String(state) : null,
            StateIso: stateIso !== null && String(stateIso).trim().length !== 0 ? String(stateIso) : null,
            Country: country !== null && String(country).trim().length !== 0 ? String(country) : null,
            ZipCode: zipCode !== null && String(zipCode).trim().length !== 0 ? String(zipCode) : null,
            CountryIso: countryIso !== null && String(countryIso).trim().length !== 0 ? String(countryIso) : null,
            PlanId: planId !== null && String(planId).trim().length !== 0 ? String(planId) : null,
            StripeToken: stripeToken !== null && String(stripeToken).trim().length !== 0 ? String(stripeToken) : null,
            SubscriptionsQuantity: subscriptionQuantity === 0 ? 1 : subscriptionQuantity,
            Email: email !== null && String(email).trim().length !== 0 ? String(email) : null,
            Username: username !== null && String(username).trim().length !== 0 ? String(username) : null,
            FirstName: firstName !== null && String(firstName).trim().length !== 0 ? String(firstName) : null,
            LastName: lastName !== null && String(lastName).trim().length !== 0 ? String(lastName) : null,
            Password: password !== null && String(password).trim().length !== 0 ? String(password) : null,
            PasswordRetype: passwordRetype !== null && String(passwordRetype).trim().length !== 0 ?
                String(passwordRetype) : null,
            CouponPlatformId: couponPlatformId !== null && String(couponPlatformId).trim().length !== 0 ?
                String(couponPlatformId) : null
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(subscriptionRequest),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getRegisterOnePageAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    };

    /**
     * Returns the subscription details
     * @param subscriptionId The id of the subscription
     * @param email The email of the customer
     * @param username The username of the customer
     * @param firstName The First Name of the customer
     * @param lastName The Last Name of the customer
     * @param status The status of the subscription
     * @param planId The plan id of the subscription
     * @param currentPage The current page
     * @param limiter The limiter pafe
     * @returns {*}
     */
    static getSubscriptionsAdvanced(subscriptionId, email, username,
                                    firstName, lastName,
                                    status, planId,
                                    currentPage, limiter) {

        let subscriptionRequest = {
            LangCode: LanguageManager.getLanguage(),
            Token: SessionManager.getSessionEmployee(),
            Username: username !== null && String(username).trim().length !== 0 ? String(username) : null,
            FirstName: firstName !== null && String(firstName).trim().length !== 0 ? String(firstName) : null,
            LastName: lastName !== null && String(lastName).trim().length !== 0 ? String(lastName) : null,
            Email: email !== null && String(email).trim().length !== 0 ? String(email) : null,
            PageFrom: currentPage,
            Limiter: limiter,
            Subscription: {
                SubscriptionId: subscriptionId !== null
                && String(subscriptionId).trim().length !== 0 ? String(subscriptionId) : null,
                Status: status !== null
                && String(status).trim().length !== 0 ? String(status) : null,
                Plan: {
                    PlanId: planId !== null
                    && String(planId).trim().length !== 0 ? String(planId) : null,
                }
            }
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(subscriptionRequest),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getSubscriptionReadAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Return the advanced usersRead
     * @param userId
     * @param username
     * @param firstName
     * @param currentPage
     * @param limiter
     */
    static getUsersAdvanced(userId, username, firstName, lastName, phoneNumber, email, roleId, lastSessionFrom,
                            lastSessionTo, createdDateFrom, createdDateTo, currentPage, limiter, requestByClient) {

        let data = {
            UserId: typeof userId !== 'undefined' && userId !== null && String(userId).trim().length !== 0 ? userId : null,
            Username: typeof username !== 'undefined' && username !== null && String(username).trim().length !== 0 ? username : null,
            FirstName: typeof firstName !== 'undefined' && firstName !== null && String(firstName).trim().length !== 0 ? firstName : null,
            LastName:  typeof lastName !== 'undefined' && lastName !== null && String(lastName).trim().length !== 0 ? lastName : null,
            PhoneNumber: typeof phoneNumber !== 'undefined' && phoneNumber !== null && phoneNumber.trim().length > 0 ?
                phoneNumber.trim().replace(/\D/g, "") : null,
            Email:  typeof email !== 'undefined' && email !== null && String(email).trim().length !== 0 ? email : null,
            RoleId:  typeof roleId !== 'undefined' && roleId !== null && String(roleId).trim().length !== 0 ? roleId : null,
            LastSessionFrom:  typeof lastSessionFrom !== 'undefined' &&  lastSessionFrom !== null && String(lastSessionFrom).trim().length !== 0 ? lastSessionFrom : null,
            LastSessionTo:  typeof lastSessionTo !== 'undefined' &&  lastSessionTo !== null && String(lastSessionTo).trim().length !== 0 ? lastSessionTo : null,
            CreatedFrom: typeof createdDateFrom !== 'undefined' &&  createdDateFrom !== null && String(createdDateFrom).trim().length !== 0 ? createdDateFrom : null,
            CreatedTo: createdDateTo !== 'undefined' &&  createdDateTo !== null && String(createdDateTo).trim().length !== 0 ? createdDateTo : null,
            PageFrom: currentPage,
            Limiter: limiter,
            LangCode: LanguageManager.getLanguage(),
            Token: SessionManager.getSessionEmployee(),
            RequestByClient: requestByClient
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getUsersAdvanceRead(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }


    /**
     * Return the advanced plans
     * @param planId
     * @param planSubstripeId
     * @param planName
     * @param currentPage
     * @param limiter
     */
    static getPlansAdvanced(planId, planSubstripeId, planName, currentPage, limiter, detailsNeeded) {

        let planRequest = {
            Id: planId !== null && String(planId).trim().length !== 0 ? planId : null,
            PlatformId: planSubstripeId !== null && String(planSubstripeId).trim().length !== 0 ? planSubstripeId : null,
            Name: planName !== null && String(planName).trim().length !== 0 ? planName : null,
            PageFrom: currentPage,
            Limiter: limiter
        };

        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Token": SessionManager.getSessionEmployee(),
            "PlanRequest": planRequest,
            "PageFrom": currentPage,
            "Limiter": limiter,
            "DetailsNeeded": detailsNeeded
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getPlansAdvaceReadAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Cancels the subscription at the backend
     * @param subscriptionId The id of the subscription to cancel
     * @param cancelAtPeriodEnd If cancelling when period ends
     * @param cancellationReason The reason for the cancellation
     * @param isEmployee If it's an employee or not
     * @returns {*}
     */
    static cancelSubscription(subscriptionId, cancelAtPeriodEnd, cancellationReason, isEmployee) {

        let token;
        if (isEmployee)
            token = SessionManager.getSessionEmployee();
        else
            token = SessionManager.getSession();

        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Token": token,
            "SubscriptionId": subscriptionId,
            "CancelAtPeriodEnd": cancelAtPeriodEnd,
            "CancellationReason": cancellationReason
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getCancellationAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    static updatePlan(PlanDetails) {
        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Token": SessionManager.getSessionEmployee(),
            "PlanCreationModel": PlanDetails
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getPlanUpdateAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Inserts a new Plan
     * @param PlanDetails The plan details
     * @returns {*}
     */
    static insertPlan(PlanDetails) {

        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Token": SessionManager.getSessionEmployee(),
            "PlanCreationModel": PlanDetails
        };

        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getPlanCreateAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }


    /**
     * Returns the countries full details
     * @param onlyAvailables If call the only availables
     * @param filterByLanguage If filter by langage
     * @returns {*|Promise.<T>}
     */
    static getCountryFullDetails(onlyAvailables, filterByLanguage) {

        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Token": SessionManager.getSessionEmployee(),
            "FilterByLanguage": filterByLanguage,
            "OnlyAvailables": onlyAvailables
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getCountriesFullDetailsAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Returns the languages
     * @returns {Promise.<T>|*}
     */
    static getLanguages() {

        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Token": SessionManager.getSessionEmployee()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getLanguagesAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Get the taxes
     * @returns {Promise.<T>|*}
     */
    static getTaxes() {

        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Token": SessionManager.getSessionEmployee()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getTaxesAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Returns the products
     */
    static getProducts(onlyAvailables, requireItemProducts, filterByLanguage) {

        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "FilterByLanguage": filterByLanguage,
            "RequireItemsProducts": requireItemProducts,
            "OnlyAvailables": onlyAvailables,
            "Token": SessionManager.getSessionEmployee()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getProductsAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Returns the billing intervals
     * @returns {*|Promise.<T>}
     */
    static getBillingInterval() {

        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "FilterByLanguage": true
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getBillingIntervalAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Returns the available currencies
     * @returns {*|Promise.<T>}
     */
    static getCurrencies() {

        let data = {
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getCurrenciesAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Verifies if the chat is on or off
     */
    static getChatStatus() {

        let data = {
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getChatStatusAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Returns the user full name (employee) for the chat
     * @returns {*|Promise.<T>}
     */
    static getEmployeeFullName() {

        let data = {
            "Token": SessionManager.getSessionEmployee(),
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getUserFullNameAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Turn on or off the chat
     * @param locked true if locked, else false
     * @returns {*|Promise.<T>}
     */
    static toggleChat(locked) {

        let data = {
            "Token": SessionManager.getSessionEmployee(),
            "Status": locked,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getChatToggleAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Inserts/Updates the mini game as locked or not
     * @param locked true if locked, else false
     * @returns {*|Promise.<T>}
     */
    static insertMiniGamesLockCreate(locked) {

        let data = {
            "Token": SessionManager.getSession(),
            "MiniGamesLocked": locked,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getMiniGamesLockCreateAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Get if the mini games area is locked or not by the parent
     * @returns {*|Promise.<T>}
     */
    static getMiniGamesLock() {

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "ParentsApp": true
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getMiniGamesBlockReaderAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Insert the classes by the plans for the student
     * @param subscriptionId The selected products (string array)
     * @param profileId The profile id (The student id)
     * @returns {*|Promise.<T>}
     */
    static insertSubscriptionToUser(profileId, subscriptionId) {

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "ProfileId": profileId,
            "SubscriptionId": subscriptionId
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getAssignSeatAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Calculates the cost of the plan sending it to the back server
     * @param planId The id of the plan
     * @param quantity The quantity of the plan
     * @returns {Promise.<T>|*}
     */
    static getPlanTotalCosts(planId, quantity, couponPlatformId, stateISO, countryISO) {

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "PlanId": planId,
            "CountryIso": countryISO !== null ? countryISO : countryISO,
            "StateIso": stateISO !== null ? stateISO : stateISO,
            "CouponPlatformId": couponPlatformId !== null ? couponPlatformId : couponPlatformId,
            "SubscriptionsQuantity": quantity
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getPlanCostAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    static getAllPlans(){

        let data = {
            "Token": SessionManager.getSessionEmployee(),
            "FilterByLanguage": true,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getPlansAvailableAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Call the available plans
     */
    static getCommercialPlans() {

        let data = {
            "Token": SessionManager.getSession(),
            "CurrencyCode": CurrencyManager.getCurrency("USD"),
            "IsSchool": false,
            "IsPrivate": false,
            "OnlyAvailables": true,
            "FilterByLanguage": true,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getPlansAvailableAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * The employee create a subscription for the employee
     * @param planId The id of the plan
     * @param userId The id of the user
     * @param tokenStripe The token created by stripe
     * @returns {*|Promise.<T>}
     */
    static insertSubscriptionByEmployee(planId, userId, tokenStripe) {

        let data = {
            "Token": SessionManager.getSessionEmployee(),
            "SubTokenStripe": tokenStripe,
            "PlanId": planId,
            "Quantity": 1,
            "UserId": userId,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getSubscribeUserToPlanByEmployeeAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Creates the subscriptions according to plan id
     * @param planId The id of the plan
     * @param quantity The quantity of selected students
     * @param tokenStripe Stripe
     * @returns {*|Promise.<T>}
     */
    static createSubscriptions(planId, quantity, tokenStripe) {

        let data = {
            "Token": SessionManager.getSession(),
            "SubTokenStripe": tokenStripe,
            "PlanId": planId,
            "Quantity": quantity,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getSubscribeUserToPlanAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }


    /**
     * Updates the password profile
     * @param password The password
     * @param passwordRetype The password retype
     * @param profileId The profile Id
     * @returns {*|Promise.<T>}
     */
    static updateProfilePassword(password, passwordRetype, profileId) {

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "Password": password,
            "PasswordRetype": passwordRetype,
            "ProfileId": profileId
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getProfileUpdatePasswordAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });

    }

    /**
     * Updates the profile information
     * @param firstName
     * @param lastName
     * @param sex
     * @param dob
     * @param profileId
     */
    static updateProfileInformation(firstName, lastName, sex, dob, profileId) {

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "FirstName": firstName,
            "LastName": lastName,
            "Gender": sex,
            "DoB": dob,
            "ProfileId": profileId
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getProfileUpdateInformationAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });

    }

    /**
     * Returns the profile information
     * @returns {Promise.<T>|*}
     */
    static getProfileInformation(profileId) {

        let data = {
            "Token": SessionManager.getSession(),
            "ProfileId": profileId,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getProfileInformationReadAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return (err);
            });
    }

    /**
     * Update user main address
     * @param addressLine1
     * @param addressLine2
     * @param city
     * @param state
     * @param country
     * @param countryIsoCode
     * @param zipCode
     * @returns {*|Promise.<T>}
     */
    static updateUserMainAddress(addressLine1, addressLine2, city, state, country, countryIsoCode, zipCode) {

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "AddressLine1": addressLine1,
            "AddressLine2": addressLine2,
            "City": city,
            "State": state,
            "StateIso": state,
            "Country": country,
            "CountryIsoCode": countryIsoCode,
            "ZipCode": zipCode
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getUserMainAddressUpdateAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Inserts the new payment method in the db
     * @param stripeToken
     * @returns {*|Promise.<T>}
     */
    static insertNewPaymentMethod(stripeToken) {

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "SubTokenStripe": stripeToken
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getUpdatePaymentMethodAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });

    }


    /**
     * Inserts the new password for the main account
     * @param oldPassword The current password
     * @param newPassword The new password
     * @param newPasswordRetype The new password retype
     * @returns {Promise.<T>|*}
     */
    static insertNewPassword(oldPassword, newPassword, newPasswordRetype) {

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "OldPassword": oldPassword,
            "Password": newPassword,
            "PasswordRetype": newPasswordRetype
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        return fetch(Settings.getUserNewPasswordInsertAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Returns the student average by a specific lesson
     * @param profileId The student Id
     * @param lessonId The lesson Id
     */
    static getStudentLessonAverage(profileId, lessonId) {

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "ProfileId": profileId,
            "LessonId": lessonId
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getStudentLessonAverageApi(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Return the student average
     * @param {*} profileId : The profile id of the student
     * @param {*} productId : The product id that represents the class
     * @public
     */
    static getStudentAverage(profileId, productId) {

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "ProfileId": profileId,
            "ProductId": productId
        };
        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getStudentAverageAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Return the main account profiles
     * @param {*} profileId : The profile id of the student
     * @public
     */
    static getProfileProducts(profileId) {

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage(),
            "ProfileId": profileId
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getProfileProductsAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return (err);
            });
    }

    /**
     * Return the main account profiles
     *
     * @public
     */
    static getProfiles(firstName, lastName, username, pageFrom, limiter) {

        let data = {
            "Token": SessionManager.getSession(),
            "OnlyActive": false,
            "LangCode": LanguageManager.getLanguage(),
            "Limiter": limiter,
            "PageFrom": pageFrom,
            "Username": username,
            "FirstName": firstName,
            "LastName": lastName
        };
        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getProfilesAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return (err);
            });
    }

    /**
     * Returns the user subscriptions details by the user plan agreement id
     * @param userPlanAgreemendId
     * @returns {*|Promise.<T>}
     */
    static getUserSubscriptionDetails(userPlanAgreemendId) {

        let data = {
            "Token": SessionManager.getSession(),
            "UserPlanAgreement": userPlanAgreemendId,
            "OnlyActive": false,
            "LangCode": LanguageManager.getLanguage()
        };
        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getUserSubscriptionsAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return JSON.parse(responseData);
            })
            .catch(function (err) {
                return err;
            });
    }

    /**
     * Get User subscribed items
     * @returns {*|Promise.<T>}
     */
    static getUserSubscribedItems() {

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage()
        };
        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getItemsSubscribedUsersAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return JSON.parse(responseData);
            })
            .catch(function (err) {
                return err;
            });
    }

    /**
     * Return the user subscriptions (With Stripe)
     *
     * @public
     */
    static getUserSubscriptions() {

        let data = {
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage()
        };
        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getUserSubscriptionsAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return JSON.parse(responseData);
            })
            .catch(function (err) {
                return err;
            });
    }

    /**
     * Return the user quizzes tries according to the quiz and profile id
     *
     * @param {string} lessonId : The id of the quiz we want to check how many times the uses did tried
     * @public
     */
    static getLessonExams(lessonId) {

        let data = {
            "Token": SessionManager.getSession(),
            "LessonId": lessonId,
            "OnlyActive": false,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getLessonExamsAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Return the user quizzes tries according to the quiz and profile id
     *
     * @param {string} quizId : The id of the quiz we want to check how many times the uses did tried
     * @param {string} profileId : The id of the profile (student) we want to check
     * @public
     */
    static getQuizzesTries(quizId, profileId) {

        let data = {
            "Token": SessionManager.getSession(),
            "ProfileId": profileId,
            "QuizId": quizId,
            "OnlyActive": false,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getUserQuizzesTriesAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return JSON.parse(responseData);
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Return the user quiz details
     *
     * @param {string} userQuizId : The user quiz id from the selection
     * @public
     */
    static getUserQuizDetails(userQuizId) {

        let data = {
            "Token": SessionManager.getSession(),
            "UserQuizId": userQuizId,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getUserQuizDetailsAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return JSON.parse(responseData);
            })
            .catch(function (err) {
                return err;
            });
    }

    /**
     * Verifies if the username is available
     * @param username The username to check
     */
    static verifyIfUsernameIsAvailable(username) {
        // The data we are going to send in our request
        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Username": username
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData = {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getUsernameAvailabilityAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return JSON.parse(responseData).Availability;
            })
            .catch(function (err) {
                return err;
            });
    }


    /**
     * Return the lessons of the product
     * @param productId : product id representing the class
     */
    static getProductLessons(productId) {

        let data = {
            "Token": SessionManager.getSession(),
            "ProductId": productId,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getProductLessonsAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err;
            });
    }


    /**
     * Verifies if the email is available
     * @param email The email
     */
    static isEmailAvailable(email) {

        // The data we are going to send in our request
        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Email": email
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData = {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getEmailAvailabilityAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData).Availability);
            })
            .catch(function (err) {
                return err;
            });
    }


    /**
     * Returns the syllabus
     * @param productId The id of the product that represents the class
     * @param lessonId The lesson id
     */
    static getSyllabus(productId, lessonId) {

        var data = {
            "Token": SessionManager.getSession(),
            "ProductId": productId,
            "LessonId": lessonId,
            "LangCode": LanguageManager.getLanguage()
        };
        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getSyllabusReadAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err;
            });
    }

    /**
     * Update user info by admin
     * @param username
     * @param password
     * @param passwordRetype
     * @param email
     * @param firstname
     * @param lastname
     * @param phone
     * @param addressLine1
     * @param addressLine2
     * @param city
     * @param state
     * @param countryIso
     * @param zipCode
     * @param country
     * @param roleId
     * @param usernameChange If the username was changed
     * @param passwordChange If the passowrd was changed
     * @param emailChange If the email was changed
     * @param nameChange If the name was changed
     * @param phoneChange If the phone was changed
     * @param addressChange If the address was changed
     * @param roleChange If the role was changed
     * @param userId The id of the user.
     * @param paymentChange If the payment was change or not
     * @param substripeToken The stripe token of the new payment method
     */
    static updateUserInfoByAdmin(username, password, passwordRetype, email, firstname,
                                 lastname, phone,
                                 addressLine1, addressLine2, city, state, countryIso, zipCode, country,
                                 roleId,
                                 substripeToken,
                                 usernameChange, passwordChange, emailChange, nameChange, phoneChange,
                                 addressChange, roleChange, paymentChange,
                                 userId)
    {

        let data = {
            "Username": username,
            "Password": password,
            "PasswordRetype": passwordRetype,
            "Email": email,
            "FirstName": firstname,
            "LastName": lastname,
            "Phone": phone,
            "DoB": null,
            "AddressLine1": addressLine1,
            "AddressLine2": addressLine2,
            "City": city,
            "State": state,
            "StateIso": state,
            "CountryIso": countryIso,
            "ZipCode": zipCode,
            "Country": country,
            "Gender": null,
            "LangCode": LanguageManager.getLanguage(),
            "Token": SessionManager.getSessionEmployee(),
            "RoleId": roleId,
            "UsernameChange": usernameChange,
            "PasswordChange": passwordChange,
            "EmailChange": emailChange,
            "NameChange": nameChange,
            "PhoneChange": phoneChange,
            "AddressChange": addressChange,
            "RoleChange": roleChange,
            "UserId": userId,
            "StripeToken": substripeToken,
            "PaymentMethodChange": paymentChange
        };


        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getUserInfoUpdateByAdminAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Register the client via an admin window
     * @param username The username
     * @param password The password
     * @param passwordRetype The password retyping
     * @param email The email of the client
     * @param firstname The first name of the client
     * @param lastname The last name of the client
     * @param phone The phone of the client
     * @param addressLine1 The address line 1
     * @param addressLine2
     * @param city
     * @param state
     * @param countryIso
     * @param zipCode
     * @param country
     * @param roleId
     * @returns {*|Promise.<T>}
     */
    static registerUserByAdmin(username, password, passwordRetype, email, firstname,
                          lastname, phone, addressLine1, addressLine2, city, state, countryIso, zipCode, country,
                        roleId) {

        let data = {
            "Username": username,
            "Password": password,
            "PasswordRetype": passwordRetype,
            "Email": email,
            "FirstName": firstname,
            "LastName": lastname,
            "Phone": phone,
            "DoB": null,
            "AddressLine1": addressLine1,
            "AddressLine2": addressLine2,
            "City": city,
            "State": state,
            "StateIso": state,
            "CountryIso": countryIso,
            "ZipCode": zipCode,
            "Country": country,
            "Gender": null,
            "LangCode": LanguageManager.getLanguage(),
            "Token": SessionManager.getSessionEmployee(),
            "RoleId": roleId
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getUserRegisterByAdminAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }


    /**
     * Registers the profile
     * @param username The username of the profile
     * @param password The password of the profile
     * @param passwordRetype The password of the profile (retype)
     * @param firstname The firstname
     * @param lastname The lastname
     * @param sex The sex
     * @param dob The date of the birth
     * @returns {*|Promise.<T>}
     */
    static registerProfile(subscriptionId, username, password, passwordRetype, firstname,
                           lastname, sex, dob) {

        let data = {
            "SubscriptionId": subscriptionId,
            "Username": username,
            "Password": password,
            "PasswordRetype": passwordRetype,
            "FirstName": firstname,
            "LastName": lastname,
            "DoB": dob,
            "Gender": sex,
            "Token": SessionManager.getSession(),
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData =
        {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getRegisterProfileAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Verifies the login of the employee
     * @param username The username to check
     * @param password The password
     * @param callback The callback of the user
     */
    static getLoginEmployee(username, password, callback) {

        // The data we are going to send in our request
        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Username": username,
            "Password": password
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData = {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        fetch(Settings.getLoginEmployeeAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                callback(JSON.parse(responseData));
            })
            .catch(function (err) {
                console.log(err);
            });
    }

    /**
     * Verifies the login
     * @param username The username to check
     * @param password The password
     * @param callback The callback of the user
     */
    static getLogin(username, password, callback) {
        // The data we are going to send in our request
        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Username": username,
            "password": password
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData = {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        fetch(Settings.getLoginAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                callback(JSON.parse(responseData));
            })
            .catch(function (err) {
                console.log(err);
            });
    }

    /**
     * Return the address of the main account
     */
    static getUserMainAddress() {

        let data = {
            "LangCode": LanguageManager.getLanguage(),
            "Token": SessionManager.getSession()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData = {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getUserMainAddressAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Returns the countries
     */
    static getCountries(countryIso) {

        let data = {
            "LangCode": LanguageManager.getLanguage()
        };

        if (countryIso != null)
            data.CountryIsoAlpha3 = countryIso;

        // The parameters we are gonna pass to the fetch function
        let fetchData = {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getCountriesAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }

    /**
     * Return the states or provinces if the country has one
     * @param countryISO
     * @returns {Promise.<T>|*}
     */
    static getStateProvinces(countryISO) {

        let data = {
            "CountryIsoAlpha3": countryISO,
            "LangCode": LanguageManager.getLanguage()
        };

        // The parameters we are gonna pass to the fetch function
        let fetchData = {
            method: 'POST',
            body: JSON.stringify(data),
            dataType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        return fetch(Settings.getStateProvincesAPI(), fetchData)
            .then((response) => {
                return response.json(); // This is required to handle the response data
            })
            .then((responseData) => {
                return (JSON.parse(responseData));
            })
            .catch(function (err) {
                return err.toString();
            });
    }
}

export default ApiCalls;